import api from "../api";

const getSimulatorReservations = async (simulatorId, dateTime) => {
  try {
    const cacheBuster = Date.now();
    const response = await api.get(

      `${process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT}/app/appointment/simulator/available-times?storeSimulatorId=${simulatorId}&date=${dateTime}&_t=${cacheBuster}`,
      {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('There was a problem with the axios operation:', error);
    throw error;
  }
};

export default getSimulatorReservations;
